module.exports = __webpack_public_path__ + "static/media/tutor-Bimg3m.e445f259.jpg";